import {getImageUrl, imageRefCallback} from "@/components/cdnImage/utils.ts";

interface CDNImageProps {
  className?: string;
  alt?: string;
  src?: string;
  domain?: string;
  title?: string;
}

export const CDNImage = ({className, alt, src, domain, title}: CDNImageProps) => {
  return <img className={className} alt={alt} title={title} src={getImageUrl(src, domain)} ref={imageRefCallback} />;
};
